
import store from '../store'
export function getAdInfo(parkId) {
    // store.commit('SET_ABSHOW',false);
    let isOpenAd = store.getters.isOpenAdvertising;
    console.log(isOpenAd,'store.getters.isOpenAdvertising');
    if (isOpenAd == 1) {
        this.$loadScript("http://sdk.anbokeji.net/adv/index.js", () => {
            const st = document.querySelector("#anbo-ad-st");
            console.log(st,'st');
            if (st) {
                document.body.removeChild(st);
            }
            const script = document.createElement("script");
            console.log(script,'script');
            script.type = "text/javascript";
            script.id = "anbo-ad-st";
            // let parkid = 320500202112153662
            script.innerHTML =
                // __anbo_adv_sdk__.init({appid: "ab377e5HRwupcJU6po", adPosId: 4,parkid});
                __anbo_adv_sdk__.init({appid: "ab377e5HRwupcJU6po", adPosId: 4,parkId});
            document.body.append(script);

            document.querySelector(".advwrap").innerHTML = "<anboadv @show='advShow'></anboadv>";
            console.log("111111111111");
            console.log(  window.advShow,'window.advShow');

            window.advShow = res => {
                console.log("22222222222222");
                var eles = document.getElementsByClassName('c')[0];
                var anboads = document.getElementsByClassName('anbo-ads')[0];
                var lastIndex = eles.src.indexOf('?');
                console.log(eles,'eles');
                if(lastIndex<1){
                    eles.setAttribute('src',eles.src);
                }else{
                    var url = eles.src.substring(0,lastIndex);
                    eles.setAttribute('src',url);
                }
                anboads.style.padding = "0 10px";
                // store.commit('SET_ABSHOW',true)
            };
        });
    }

}
//sdk.anbokeji.net/adv/index.js
//sdk-test.anbokeji.net/adv/index.js
